"use client";

import { useEffect, useState } from "react";
import { useI18n } from "@/i18n/context";
import { initWaitlist, openWaitlistModal } from "./engine";
import { waitlistApi } from "@/lib/waitlistApi";
import "./waitlist.css";

// Home-only floating pill. Rendered by React; the engine runs for the live
// counter + modal. Hidden when the waitlist is globally disabled (app is live).
export function WaitlistPill() {
  const { locale } = useI18n();
  const [shown, setShown] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const cleanup = initWaitlist({ pill: false });
    const id = window.setTimeout(() => setShown(true), 1500);
    // Hide the pill entirely if the waitlist is turned off.
    waitlistApi
      .config()
      .then((c) => {
        if (!c.enabled) setHidden(true);
      })
      .catch(() => {});
    return () => {
      window.clearTimeout(id);
      cleanup();
    };
  }, []);

  if (hidden) return null;

  const label = locale === "fr" ? "Rejoindre la liste d'attente" : "Join the waitlist";
  const sub = locale === "fr" ? "inscrits sur la liste d’attente" : "people on the waitlist";

  return (
    <button
      className={`wl-pill${shown ? " in" : ""}`}
      type="button"
      aria-label={label}
      onClick={() => openWaitlistModal()}
    >
      <span className="wl-pill-dot" />
      <span className="wl-pill-text">
        <span className="wl-pill-main">{label}</span>
        <span className="wl-pill-sub">
          <strong data-wl-count suppressHydrationWarning>
            {"—"}
          </strong>{" "}
          {sub}
        </span>
      </span>
      <svg
        className="wl-pill-arrow"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </button>
  );
}
